import { Theme, css } from '@emotion/react';

export const consumerHelp = ({ spacing }: Theme) => css`
  & p {
    margin-bottom: ${spacing(1)}px;
  }
  & ol,
  & ul {
    // We want to go with the user stylesheet default for many things related to lists.
    list-style: revert;
    margin: revert;
    // But with a further override for margin-top, which works in combination
    // with the paraBeforeList style to avoid extra space just before any FAQ-item lists.
    margin-top: 0;
    padding: revert;
  }
  & li {
    margin: revert;
    padding: revert;
  }
`;

export const consumerHelpSection = ({ spacing, colors }: Theme) => css`
  margin-bottom: ${spacing(5)}px;
  padding-bottom: ${spacing(5)}px;
  border-bottom: 1px solid ${colors.borderDefault};
`;

export const consumerHelpItem = ({ spacing, colors }: Theme) => css`
  margin-bottom: ${spacing(4)}px;
`;

export const consumerHelpTitle = ({ spacing, colors }: Theme) => css`
  border-bottom: 1px solid ${colors.borderDefault};
  padding-bottom: ${spacing(4)}px;
`;

/* The &&&& is a little hack to make sure that this has higher specificity than the
 * .css-for-consumerHelp p {} selector generated above. */
export const paraBeforeList = css`
  &&&& {
    margin-bottom: 0;
  }
`;
